import { useAPIQuery, UserAccountApi } from "melco-shared-logic";

// export const useAccountGetPendingTransaction = () => {
//   console.log("accountGetPendingTransaction called");
//   const [accountGetPendingTransaction] = useAPIAction(
//     UserAccountApi,
//     async (api: UserAccountApi, transactionId: string) => {
//       const data = await api.accountGetPendingTransaction({ transactionId: transactionId });
//       return { successMessages: [], data };
//     },
//     {
//       translationPrefix: "",
//     }
//   );
//   return useCallback(
//     (transactionId: string) => {
//       return accountGetPendingTransaction(transactionId);
//     },
//     [accountGetPendingTransaction]
//   );
// };

export const useAccountGetPendingTransaction = (
  transactionId: string
  ,
  enabled: boolean
) => {

  return useAPIQuery(UserAccountApi, ["machineLicensesPendingTransaction", transactionId], async (api) => {
    if (transactionId == null) {
      return;
    }

    return api.accountGetPendingTransaction({ transactionId: transactionId });
  }
    , {
      queryOptions: {
        enabled: enabled && !!transactionId
      }
    });
};